// Lib
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isEmpty } from 'lodash/fp';

// Selectors
import { sortedCurrentBoardPublishLinkViewersSelector } from './publishedBoardViewersSelector';
import { popupOpenSelector } from '../../../../../../../components/popupPanel/popupOpenSelector';
import { fetchCurrentBoardPublishedBoardViewers } from './publishedBoardViewersActions';

// Actions
import { closePopup as closePopupAction } from '../../../../../../../components/popupPanel/popupActions';

// Components
import FloatingPanel from '../../../../../../../components/tooltips/FloatingPanel';
import PublishBoardViewerEntry from './PublishBoardViewerEntry';
import PopupPanelMouseManager from '../../../../../../../components/popupPanel/PopupPanelMouseManager';

// Constants
import { TooltipAlignment, TooltipPositions } from '../../../../../../../components/tooltips/tooltipConstants';
import { PopupIds } from '../../../../../../../components/popupPanel/popupConstants';

// Styles
import './PublishBoardViewersPopup.scss';

const mapDispatchToProps = (dispatch) => ({
    closePopup: () => dispatch(closePopupAction(PopupIds.PUBLISHED_VIEWERS, false)),
    dispatchFetchCurrentBoardPublishedBoardViewers: () => dispatch(fetchCurrentBoardPublishedBoardViewers()),
});

const mapStateToProps = createStructuredSelector({
    viewers: sortedCurrentBoardPublishLinkViewersSelector,
    popupOpen: popupOpenSelector(PopupIds.PUBLISHED_VIEWERS),
});

const PublishBoardViewersPopup = (props) => {
    const { viewers, popupOpen, closePopup, dispatchFetchCurrentBoardPublishedBoardViewers } = props;

    if (!popupOpen || isEmpty(viewers)) return null;

    useEffect(() => {
        if (!popupOpen) return;
        dispatchFetchCurrentBoardPublishedBoardViewers();
    }, [popupOpen]);

    return (
        <FloatingPanel
            pollPosition
            className="PublishBoardViewersPopup light"
            selector=".published-board-viewer-count"
            arrowHeight={0}
            arrowWidth={0}
            alignment={TooltipAlignment.START}
            distance={10}
            position={TooltipPositions.BOTTOM}
        >
            <PopupPanelMouseManager closePopup={closePopup} visible popupId={PopupIds.PUBLISHED_VIEWERS}>
                <div className="published-board-viewers-popup-container">
                    {viewers.map((viewer) => (
                        <PublishBoardViewerEntry key={viewer.id} {...viewer} />
                    ))}
                </div>
            </PopupPanelMouseManager>
        </FloatingPanel>
    );
};

PublishBoardViewersPopup.propTypes = {
    popupOpen: PropTypes.bool,
    viewers: PropTypes.array,
    closePopup: PropTypes.func,
    dispatchFetchCurrentBoardPublishedBoardViewers: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(PublishBoardViewersPopup);
